"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giorgio-della-richinvelda": {
    "c94607ca": [{
      "hkey": "113b0db8",
      "slug": "rauscedo-domanins",
      "name": "Rauscedo-Domanins",
      "primary": true,
      "skipSearch": false
    }],
    "domanins": [{
      "hkey": "113b0db8",
      "slug": "rauscedo-domanins",
      "name": "Rauscedo-Domanins",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giorgio-della-richinvelda"
    }],
    "4d8d25bb": [{
      "hkey": "113b0db8",
      "slug": "rauscedo-domanins",
      "name": "Rauscedo-Domanins",
      "primary": true,
      "skipSearch": false
    }],
    "rauscedo": [{
      "hkey": "113b0db8",
      "slug": "rauscedo-domanins",
      "name": "Rauscedo-Domanins",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giorgio-della-richinvelda"
    }]
  }
};
exports["default"] = _default;